// use require to prevent src dir from being copied to dist

import config from './config';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageData = require('../package.json');

function stringifyObject(unTypedObject: unknown) {
  const object = unTypedObject as {
    [key in string | number | symbol]: unknown;
  };
  const objectToStringify: { [key in string | number]: unknown } = {};
  for (const property in object) {
    if (typeof object[property] !== 'object') {
      objectToStringify[property] = object[property];
    } else {
      objectToStringify[property] = stringifyObject(
        objectToStringify[property] as {
          [key in string | number]: unknown;
        },
      );
    }
  }
  return JSON.stringify(objectToStringify);
}

export default function logger(
  message: string,
  isError = false,
  ...data: unknown[]
): void {
  if (config.logger.enabled) {
    if (typeof message === 'object') {
      message = JSON.stringify(message);
    }
    message = `[vault ${packageData.version}] ${message}`;
    const consoleMethod = isError ? 'error' : 'log';
    if (data.length) {
      message += `\r\nData: ${JSON.stringify(data)}`;
    }
    // log as much navigator info as possible
    if (isError) {
      message += `\r\nNavigator: ${stringifyObject(navigator)}`;
    }
    // eslint-disable-next-line no-console
    console[consoleMethod](message);
  }
}

export const logVgsFormSubmitResponse = ({
  formName,
  responseStatus,
  data,
  errors,
}: {
  formName: string;
  responseStatus: number;
  data: string | unknown;
  errors?: Error[];
}) => {
  logger(`${formName} vgs form submit response status: ${responseStatus}`);
  logger(`${formName} vgs form submit data:`, false, data);
  if (errors && errors.length > 0) {
    logger(`${formName} vgs form submit errors:`, true, errors);
  }
};
